var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaturation = function SvgSaturation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000",
    strokeWidth: 0.225
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.54 3.623a16.39 16.39 0 0 0-1.9-2.029C6.376 1.361 5.89 1 6 1c.11 0-.376.361-.64.594a16.39 16.39 0 0 0-1.9 2.029C1.937 5.536 1 7.488 1 9c0 2.808 2.21 5 5 5s5-2.192 5-5c0-1.512-.937-3.464-2.46-5.377ZM6 15c-3.314 0-6-2.612-6-6 0-4 5.14-9 6-9 .86 0 6 5 6 9 0 3.388-2.686 6-6 6Z"
  })));
};
export default SvgSaturation;